"use strict";
Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _classesModel = require('../classes/Model');

var _classesModel2 = _interopRequireDefault(_classesModel);

var _classesBrowser = require('../classes/Browser');

var _classesBrowser2 = _interopRequireDefault(_classesBrowser);

/**
*  
*/

var User = (function (_Model) {
    _inherits(User, _Model);

    function User(data) {
        _classCallCheck(this, User);

        _get(Object.getPrototypeOf(User.prototype), 'constructor', this).call(this, data);
    }

    /**
    * User class representing current user.
    */

    _createClass(User, null, [{
        key: '_getNotFillable',
        value: function _getNotFillable() {
            /**
            * protect attributes from mass assigment
            */
            return ['albums', 'tracks'];
        }
    }, {
        key: '_getType',
        value: function _getType() {
            return 'users';
        }
    }, {
        key: 'me',
        value: function me() {
            var browser = new _classesBrowser2['default']({
                type: this._getType(),
                factory: Me
            });
            return browser;
        }
    }, {
        key: 'findMe',
        value: function findMe() {
            return this.me().get();
        }
    }]);

    return User;
})(_classesModel2['default']);

var Me = (function (_User) {
    _inherits(Me, _User);

    function Me() {
        _classCallCheck(this, Me);

        _get(Object.getPrototypeOf(Me.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Me, null, [{
        key: '_getType',
        value: function _getType() {
            return 'me';
        }
    }]);

    return Me;
})(User);

exports['default'] = User;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/spotify-client/lib/entities/User.js
 ** module id = 104
 ** module chunks = 0
 **/